import { create } from 'zustand';
import { ImageShape } from '@/shared/lib/types';
import { AppPavilionDataMap } from '../utils/getStandsDataMap';

export type PavilionsState = {
    pavilionDataLoading: boolean;
    pavilionDataError: string | null;
    pavilionData: {
        data: Record<string, Record<string, AppPavilionDataMap>>;
        images: Record<string, ImageShape | null>;
    };
};

export const usePavilionsStore = create<{
    pavilions: PavilionsState;
    setPavilions: (data: any) => void;
    setLoading: (loading: boolean) => void;
    setError: (error: string | null) => void;
}>((set) => ({
    pavilions: {
        pavilionData: { data: {}, images: {} },
        pavilionDataLoading: false,
        pavilionDataError: null,
    },
    setPavilions: (data) =>
        set((state) => ({
            pavilions: {
                ...state.pavilions,
                pavilionData: data,
                pavilionDataLoading: false,
                pavilionDataError: null,
            },
        })),
    setLoading: (loading) =>
        set((state) => ({
            pavilions: {
                ...state.pavilions,
                pavilionDataLoading: loading,
                pavilionDataError: null,
            },
        })),
    setError: (error) =>
        set((state) => ({
            pavilions: {
                ...state.pavilions,
                pavilionDataError: error,
                pavilionDataLoading: false,
            },
        })),
}));

export const usePavilionsValue = () => usePavilionsStore((state) => state.pavilions);

export const useSetPavilionsState = () => usePavilionsStore((state) => state.setPavilions);
export const useSetLoadingState = () => usePavilionsStore((state) => state.setLoading);
export const useSetErrorState = () => usePavilionsStore((state) => state.setError);
